export default __webpack_public_path__ + "mytributes/images/modal-hero.jpg";